/** @format */

import React from "react";
import Forums from "../components/elements/Forums";

const Home = () => {
  return (
    <React.Fragment>
      <Forums />
    </React.Fragment>
  );
};

export default Home;
